module.exports = __webpack_public_path__ + "media/images/faces/male/30-969731c0e06923f183b6db5bf2e664c2.jpg";